const routes = {
  '/': {
    name: 'Partner'
  },
  '/home': {
    name: 'Startseite'
  },
  '/profiles': {
    name: 'Profilseiten',
    nameSingular: 'Profilseite'
  },
  '/termine': {
    name: 'Termine'
  },
  '/settings': {
    name: 'Einstellungen'
  }
}

export default routes



// WEBPACK FOOTER //
// ./src/routes.js